import React, { useEffect, useState } from 'react';
import { useNavigate  , useSearchParams } from "react-router-dom";

import {SvgOk} from '../Svg.js';


function DataParaForm(dataEntrada) {
    const [month, day, year] = dataEntrada.split("/");
    const formattedDate = `${year}-${month}-${day}`;  
    return formattedDate; 
  }
  
  function DataParaDb(dataEntrada) {
    const [year, month, day ] = dataEntrada.split("-"); 
    const formattedDate = `${month}/${day}/${year}`;  
    return formattedDate; 
  }   
  
function FormCliente() {
    const navigate = useNavigate(); // Inicialize o hook


  const [formData, setFormData] = useState({
    Id: "",
    Tipo: "",
    Nome: "",
    DataAte: "",
    Situacao: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    //alert(name+' '+value);
    
    if (name === "xxDataAte") {
        
        // Converte o valor para o formato yyyy-MM-dd
        const [day, month, year] = value.split("/"); // Caso venha no formato dd/MM/yyyy
        const formattedDate = `${year}-${month}-${day}`; // Formata para yyyy-MM-dd
        setFormData({ ...formData, [name]: formattedDate });
      } else {
        setFormData({ ...formData, [name]: value });
      }
    
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    for (const key in formData) {
      if (key === "DataAte")  {formData[key] = DataParaDb(formData[key]); };
      if (key === "Situacao")  {
        if (formData[key] === "") {
          formData[key] = "Ativo"; }};
        //alert(key+ formData[key]);
        params.append(key, formData[key]);
    }
    console.log('params----->', params, formData);
    navigate('/FormCli');
    const response = await fetch('http://www.criar.com.br:3000/cliente', {
      method: "POST",
      headers: {"Content-Type": "application/json", },
      body: JSON.stringify(formData),
      //headers: {"Content-Type": "application/x-www-form-urlencoded", },
      //body: params.toString(), 
    });
    console.log(response);
  };

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id"); 
  formData.Id = id;
  useEffect(() => {
    fetch(`http://www.criar.com.br:3000/clienteid?id=${id}`)
      .then(response => {
        if (!response.ok) {
          throw new Error("Erro ao buscar os dados!");
        }
        return response.json();
      })
      .then(data => {
        setFormData(prevState => ({ ...prevState, Tipo:data.Tipo, Nome:data.Nome, DataAte:DataParaForm(data.DataAte), Situacao:data.Situacao }));        
        console.log('data-0---->');
      })
      .catch(error => console.error("Erro ao buscar os dados:", error));
  }, [id, setFormData]);
  
  
   return (

<div class="areabox">
	
	<h1>Cliente</h1>
		<div class='row'>
		<div class='col-p'>
			<div class='card1'>
			</div>
		</div>
		<div class='col-4'>
			<div class='card1'>
				<h2>Alterar</h2>

<form onSubmit={handleSubmit}>
<div class="form-group">
<label for="Id" class="form-control">Id:</label><br/>
<input type="text" name="Id"       size="10" value={id} onChange={handleChange} /> <br /><br />

<label for="Tipo" class="form-control">Tipo:</label><br/>
<input type="text" name="Tipo"     size="30" value={formData.Tipo} onChange={handleChange}/><br /><br />

<label for="Nome" class="form-control">Nome:</label><br/>
<input type="text" name="Nome"     size="60" value={formData.Nome} onChange={handleChange} /><br /><br />

<label for="DataAte" class="form-control">Data Até:</label><br/>
<input type="date" name="DataAte"  size="50" value={formData.DataAte} onChange={handleChange} /> <br /><br />

<label for="Situacao" class="form-control">Situação:</label><br/>
<select name="Situacao" size="1" value={formData.Situacao} onChange={handleChange}>
<option value="Ativo">Ativo</option>
<option value="Inativo">Inativo</option>
<option value="Em Dia">Em Dia</option>
<option value="Em Atrazo">Em Atrazo</option>
<option value="Cancelado">Cancelado</option>
</select>

<br /><br />
<button type="submit" class="botaocinsa"><SvgOk/><br/>Alterar</button><br/><br/>

</div>
</form>

</div>
</div>
	</div>
</div>  



  );
}

export default FormCliente;